export default "__VITE_ASSET__CBbLAf0e__"